export default {
    title: 'Lieferantenstatus ändern',
    toggleText: 'Möchten Sie die ausgewählten Lieferanten aktivieren / deaktivieren?',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren'
}